import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/assets/images/Distracker.png" alt="Distracker" />
            </div>
            <p className="footer-description">
              Plataforma avanzada de rastreo GPS para usuarios modernos. Construida con tecnología de vanguardia para ayudarte a monitorear con precisión.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/Distrackersas" className="social-link" target="_blank" rel="noopener noreferrer">
                <img src="/icons/facebook_icon.svg" alt="Facebook" className="social-icon" />
              </a>
              <a href="https://wa.me/525562076934" className="social-link" target="_blank" rel="noopener noreferrer">
                <img src="/icons/whatsapp_icon.svg" alt="WhatsApp" className="social-icon" />
              </a>
            </div>
          </div>
          
          {/* <div className="footer-section">
            <h4>Producto</h4>
            <ul className="footer-links">
              <li><a href="#features">Características</a></li>
              <li><a href="#pricing">Precios</a></li>
              <li><a href="#">API</a></li>
              <li><a href="#">App Móvil</a></li>
            </ul>
          </div> */}
          
          {/* <div className="footer-section">
            <h4>Empresa</h4>
            <ul className="footer-links">
              <li><a href="#">Acerca de</a></li>
              <li><a href="#">Carreras</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Prensa</a></li>
            </ul>
          </div> */}
          

        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Distracker. Todos los derechos reservados.</p>
          <div className="footer-bottom-links">
            <Link to="/legal">Política de privacidad</Link>
            <Link to="/legal">Términos de servicio</Link>
            <Link to="/legal">Política de cookies</Link>
            <span className="version-number">v1.2.2</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 